import React from 'react';
import Button from '@/components/lab-components/Button';
import { BUTTON_THEME, TEXT_TYPE, BREAKPOINT } from '@/utils/constants';
import SvgInline from '@/components/SvgInline/SvgInline';
import CardLabel from '../CardLabel';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Typography } from '../Typography';
import { Link } from '@latitude/link';
import { getCdrEntryBindingRichTextOptions } from '@/utils/contentfulRichTextBindings';
import './_card.scss';

const Card = ({
  location,
  data,
  cardTitleSize,
  cardDescriptionSize,
  theme,
  cardRef,
  cardTitleRef,
  cardBodyRef,
  category,
  action,
  stackedCol,
  cardNumber
}) => {
  const {
    id,
    name,
    image,
    icon,
    labelText,
    labelTheme,
    labelIcon,
    title,
    description,
    buttonTheme,
    button,
    buttonIcon,
    cardUrl
  } = data;
  const TITLE_OPTIONS_H4 = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.H4>{children}</Typography.H4>
      )
    }
  });

  const TITLE_OPTIONS_H5 = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.H5>{children}</Typography.H5>
      )
    }
  });

  const DESCRIPTION_OPTIONS_SUBTITLE = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.SUBTITLE>{children}</Typography.SUBTITLE>
      )
    }
  });

  const DESCRIPTION_OPTIONS_H6 = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.H6>{children}</Typography.H6>
      )
    }
  });

  const getButtonType = theme => {
    if (theme === 'Outline') return BUTTON_THEME.OUTLINE;
    else if (theme === 'Blue') return BUTTON_THEME.DEFAULT;
    else if (theme === 'Link') return BUTTON_THEME.LINK;
    return BUTTON_THEME.APPLICATION;
  };
  console.log('tracking', name);
  return (
    <div
      ref={cardRef?.[id]}
      className={`card-wrapper card-wrapper--${theme?.toLowerCase()}`}
      css={`
        @media (min-width: ${BREAKPOINT.XL}) {
          width: ${cardNumber <= 3 && '350px'};
        }
      `}
    >
      <Link
        href={cardUrl}
        style={{ cursor: cardUrl ? 'pointer' : 'default' }}
        trackEventData={{
          label: button?.text || name,
          location: name,
          category: category,
          action: action
        }}
        target="_self"
      >
        {image && (
          <img
            className={`card-wrapper-image card-wrapper-image--${stackedCol >
              3 ||
              (cardNumber > 3 && 'small')}`}
            src={image?.file?.url}
            alt={image?.file?.fileName}
          />
        )}
        <div className="card-wrapper-content">
          {icon && <SvgInline className="card-wrapper-icon" name={icon} />}
          {labelText && (
            <CardLabel
              text={labelText}
              theme={labelTheme}
              icon={labelIcon}
            ></CardLabel>
          )}
          {title && (
            <div ref={cardTitleRef?.[id]} className="card-wrapper-title">
              {documentToReactComponents(
                title,
                cardTitleSize === 'Heading 4'
                  ? TITLE_OPTIONS_H4
                  : TITLE_OPTIONS_H5
              )}
            </div>
          )}
          {description && (
            <p ref={cardBodyRef?.[id]} className="card-wrapper-description">
              {documentToReactComponents(
                description,
                cardDescriptionSize === 'Heading 6'
                  ? DESCRIPTION_OPTIONS_H6
                  : DESCRIPTION_OPTIONS_SUBTITLE
              )}
            </p>
          )}
          {button?.url && (
            <Button
              theme={getButtonType(buttonTheme)}
              href={button?.url}
              trackEventData={{
                label: button?.text,
                location: name,
                category: category,
                action: action
              }}
              text={button?.text}
              icon={buttonIcon}
            />
          )}
        </div>
      </Link>
    </div>
  );
};

export default Card;
